export enum FileType {
  Txt = "text/plain;charset=utf-8",
  Csv = "text/csv;charset=utf-8",
  Xlsx = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  Docx = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
}

export const downloadFile = (
  downloadFileData: any,
  fileName: string,
  type: FileType
) => {
  const content =
    type === FileType.Csv ? "\uFEFF" + downloadFileData : downloadFileData; // Adiciona o BOM (Byte Order Mark) UTF-8 no início do conteúdo CSV
  const data = new Blob([content], { type: type });
  const url = window.URL.createObjectURL(data);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
};
